export async function fetchData(url, options = {}) {
  const {
    data = null,
    headers = {},
    method = 'GET'
  } = options;

  const params = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    credentials: 'include',
    cache: 'no-store'
  };

  /* istanbul ignore else */
  if (data) {
    params.method = 'POST';
    params.body = JSON.stringify(data);
  }

  const response = await fetch(url, params);

  /* istanbul ignore else */
  if (response.status === 200) {
    return await response.json();
  }
};
